import { useSearchParams } from 'react-router-dom';

import MainTableOfAMProposedCases from './SectionsForAMProposedCases/MainTableOfAMProposedCases';

import headerPanel from '../../styles/HeaderPanel.module.css';
import TrashOfAMProposedCases from './SectionsForAMProposedCases/TrashOfAMProposedCases.jsx';

export default function AMProposedCases({ userId }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const section = searchParams.get('section') || 'main-table';

    return (
        <>
            <div className='pageWrapper'>
                {section == 'main-table' ? <MainTableOfAMProposedCases userId={userId} />
                : section == 'trash' ? <TrashOfAMProposedCases userId={userId} />
                : <a className='description'>Выберите вкладку</a>}
            </div>
        </>
    )
}